import styled from "styled-components";

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  flex-direction: row;
`;

export const StyledInputWrapper = styled.div`
  position: relative;
  flex: 1;
`;

export const StyledInput = styled.textarea`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--gray-light);
  border-radius: 4px;
  outline: none;
  box-sizing: border-box;
  background-color: transparent;
  color: var(--color-black);
  caret-color: var(--color-black);
  position: relative;
  z-index: 2;
  font-family: inherit;
    
  resize: none;
  min-height: 2rem;
  max-height: 10rem;     
  line-height: 1.5rem;
  overflow: auto;
  scrollbar-color: var(--gray-lighter) var(--color-white);
  
  &:focus {
    border-color: var(--brand-primary);
  } 
  
  &:disabled {
      background-color: var(--gray-lighter); 
      color: var(--gray-dark);  
      cursor: not-allowed;
      border-color: var(--gray-light);
      opacity: 0.6;   
  }
    
  &::placeholder {
      color: var(--gray);
      opacity: 1;
  }
`;

export const Placeholder = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--gray);
  pointer-events: none;
  background: var(--color-white);
  min-width: 100%;
`;

export const MeasureText = styled.span`
  position: absolute;
  top: -9999px;
  left: -9999px;
  white-space: pre;
  font-family: inherit;
  visibility: hidden;
`;

export const SuggestionOverlay = styled.span`
  position: absolute;
  pointer-events: none;
  white-space: pre;
  overflow: hidden;
  box-sizing: border-box;
  color: var(--gray);
`;

export const SendButton = styled.button<{ disabled: boolean }>`
    width: 100px;
    height: 40px;
    max-height: 40px;
    padding: 0;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    .rioglyph-send {
        font-size: 18px;
        position: relative;
        left: 2px;
    }
`;

export const LLL = styled.div`
  background-color: red;
    max-height: 40px;
`;
export const ErrorMessage = styled.div`
  color: red;
  margin-top: 4px;
  font-size: 14px;
`;

export const WarningMessage = styled.div`
  color: var(--gray);
  margin-top: 4px;
  font-size: 14px;
  padding-bottom: 4px;
`;

export const ImgSrc = styled.span`
  font-size: 16px;
  position: relative;
  bottom: 0.2rem;
`;
